import CalteInputRecord from "@/components/domains/calte/calteInputRecord";

export default class CalteRecord {

    constructor(private id: string, private generalCalteId: string, private calteInputRecords: CalteInputRecord[]) {
    }
}